import type { IScheduledEmail } from '@/types/email.types';

export interface ScheduledEmailsState {
  emails: IScheduledEmail[] | null;
  loadingEmails: boolean;
  errorLoadingEmails: boolean;
  /** the published version of each email (emails holds the latest drafts) - null until loaded, or after a
   * create/publish/delete changes what's published so the next reader reloads it */
  publishedEmails: IScheduledEmail[] | null;
  /** the event publishedEmails belongs to, so switching events reloads them */
  publishedEmailsEventUuid: string | null;
  loadingPublishedEmails: boolean;
  errorLoadingPublishedEmails: boolean;
  activeEmail: IScheduledEmail | null;
  loadingActiveEmail: boolean;
  errorLoadingActiveEmail: boolean;
  updatingEmail: boolean;
  errorUpdatingEmail: boolean;
  // background customization saves that have not settled yet - the editor does not wait on these
  pendingCustomizationSaves: number;
  errorSavingCustomizations: boolean;
  creatingEmail: boolean;
  errorCreatingEmail: boolean;
  deletingEmailUuid: string | null;
  errorDeletingEmail: boolean;
}

export const initialState: ScheduledEmailsState = {
  emails: null,
  loadingEmails: false,
  errorLoadingEmails: false,
  publishedEmails: null,
  publishedEmailsEventUuid: null,
  loadingPublishedEmails: false,
  errorLoadingPublishedEmails: false,
  activeEmail: null,
  loadingActiveEmail: false,
  errorLoadingActiveEmail: false,
  creatingEmail: false,
  errorCreatingEmail: false,
  updatingEmail: false,
  errorUpdatingEmail: false,
  pendingCustomizationSaves: 0,
  errorSavingCustomizations: false,
  deletingEmailUuid: null,
  errorDeletingEmail: false,
};
